import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    ContainerMui,
    ColorHex,
    BorderRadiusMui,
    Spacer
} from '../../../../styles';

import { PaiementButtonConnected } from './paiementButton/PaiementButton.connected';
import { PaiementInputConnected } from './paiementInput/PaiementInput.connected';
import { useMediaQuery } from '@material-ui/core';
import { TexteAvecInfoBulle } from '../../../../components';

export interface IPaiementSelectProps {
    onTooltipActive: () => void;
}

export const PaiementSelect: React.FC<IPaiementSelectProps> = ({
    onTooltipActive
}) => {
    const [t] = useTranslation('PaiementSelect');
    const isMobile = useMediaQuery('(max-width:640px)');

    return (
        <ContainerMui
            borderRadius={BorderRadiusMui.sm}
            border={2}
            borderColor={ColorHex.graphite}
            maxWidth={isMobile ? '100%' : '71%'}
            spacerDistance={6}
        >
            <TexteAvecInfoBulle
                label={t('paiement')}
                labelInfoBulle={
                    <>
                        <div>{t('tooltip1')}</div>
                        <br></br>
                        <div>{t('tooltip2')}</div>
                        <br></br>
                        <div>{t('tooltip3')}</div>
                        <br></br>
                        <div>{t('tooltip4')}</div>
                    </>
                }
                labelHorsEcranInfoBulle={t('paiement')}
                labelColor={ColorHex.lightGraphite5}
                isSmallerLabelInfobulle={isMobile}
                iconColorCustom={ColorHex.lightGraphite5}
                onToolTipActive={onTooltipActive}
            />
            <Spacer all={2} />
            <PaiementInputConnected />
            <PaiementButtonConnected />
        </ContainerMui>
    );
};
